module.exports = __webpack_public_path__ + "static/media/Juliana_Arbelaez_Hyg.54823f88.png";